<template>
  <div class="file">
    <label class="file-label">
      <input
        id="file"
        ref="file"
        class="file-input"
        type="file"
        name="resume"
        @input="getFileContent($event)"
      />
      <span class="file-cta">
        <span class="file-label"><slot></slot></span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  methods: {
    getFileContent(e) {
      const reader = new FileReader();

      reader.onload = () => {
        this.$emit("content", reader.result);
        document.getElementById("file").value = "";
      };

      reader.readAsText(e.target.files[0]);
    }
  }
};
</script>

<style lang="css">
.file {
  display: inline-flex;
}
</style>
